import { Button as _Button } from 'antd5';
import styled, { createGlobalStyle } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const StyledButton = styled(_Button)`
  background: ${({ theme }) => theme.buttonBackgroundColor};

  &:not(.ant-btn-dangerous) {
    border-color: ${({ theme }) => theme.buttonBorderColor};
    color: ${({ theme }) => theme.headerColor};
  }

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.secondaryBackgroundColor} !important;
  }

  &.ant-btn-primary:not(.ant-btn-dangerous) {
    &.ant-btn-background-ghost {
      color: ${({ theme }) => theme.teal};
    }

    &:not(.ant-btn-background-ghost) {
      background: ${({ theme }) => theme.teal};
      border-color: ${({ theme }) => theme.teal};
      color: #ffffff;
    }

    &:hover:not(.ant-btn-background-ghost),
    &:focus:not(.ant-btn-background-ghost) {
      background: ${({ theme }) => theme.tealActive} !important;
      border-color: ${({ theme }) => theme.tealActive} !important;
      color: #ffffff;
    }
  }

  &.ant-btn-primary.ant-btn-dangerous:hover {
    color: ${({ theme }) => theme.red};
  }

  &.ant-btn-primary.ant-btn-dangerous.ant-btn-loading {
    color: ${({ theme }) => theme.red} !important;
  }

  &.ant-btn-default.ant-btn-dangerous {
    background: ${({ theme }) => theme.buttonBackgroundColor} !important;
  }

  &[disabled],
  &[disabled]:hover,
  &.ant-btn-primary[disabled],
  &.ant-btn-primary[disabled]:hover,
  &.ant-btn-dangerous.ant-btn-primary[disabled],
  &.ant-btn-dangerous.ant-btn-primary[disabled]:hover {
    background: ${({ theme }) => theme.disabledBackground} !important;
    border-color: ${({ theme }) => theme.disabledTextColor} !important;
    color: ${({ theme }) => theme.disabledTextColor} !important;
  }

  &.ant-btn-link {
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.teal};

    &:hover {
      color: ${({ theme }) => theme.tealActive} !important;
    }
  }

  &.ant-btn > .ant-btn-icon + span {
    margin-left: 8px;
  }
`;

export const SubMenuStyles = createGlobalStyle`
  ${({ theme }) =>
    theme.themeName === Theme.Dark &&
    `
    .ant-menu-submenu {
      .ant-menu {
        background: ${theme.tertiaryBackgroundColor};
        color: ${theme.headerColor};
      }

      .ant-menu-item-group-title {
        color: ${theme.disabledTextColor};
      }
    }
  `}
`;
